/*
 * filename: table.js
 * Get the user data from store and show
 * */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import { Field, reduxForm, reset } from 'redux-form';
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import ExportingData from 'highcharts/modules/export-data';
import { renderAutoCompleteMultipleSelection, renderAutoCompleteScheduling, renderCheckBox, renderDateField } from '../components/reduxFields';
import { getOrganizationBillableHoursGraph } from '../modules/Dashboards/actions/StaffDashboardActions';
Exporting(Highcharts);
ExportingData(Highcharts);
/**
 * A simple table demonstrating the hierarchy of the `Table` component and its sub-components.
 */
class KPIScheduledHours extends Component {

  constructor(props) {
    super(props);        
    this.state = {                    
        xAxisDateOption: [],  
        isReset: false
      };    
  }

  // loadOrganizationBillableHoursGraph() {
  //   let searchObj3 = {
  //     contain_filters: {
  //       fromDate: this.state.FromBillableHoursDate ? moment(this.state.FromBillableHoursDate).format('YYYY-MM-DD') : new Date(),
  //       toDate: this.state.ToBillableHoursDate ? moment(this.state.ToBillableHoursDate).format('YYYY-MM-DD') : new Date(),
  //       payerIds: [],
  //       appointmentTypeIds: [],
  //       staffIds: [],
  //       patientIds: [],
  //       locationIds: [],
  //       //IsBillable: isBillable ? true : false, 
  //     }, 
  //   };
  //   this.props.getOrganizationBillableHoursGraph(searchObj3);
  // }

  componentDidMount = () => {
    this.highchartsHandler();
  }

  componentDidUpdate = () => {
      if(this.props.dataAnalytics !== null) {
          this.highchartsHandler();
      }
  }

  handleReset = () => {
    this.props.dispatch(reset('KPIScheduledHoursForm'));    
    this.props.handleResetBillableKPI();
  };

  highchartsHandler = () => {
    let finalData = [];    
    let xAxisLabel = 'Hours';        
    let yAxisLabel = 'Status';
    let gridlinesWidth = 0;
    let totalHours = 0;    
    let totalHoursToDisplay = '';  
    if (this.props.dataAnalytics !== null && this.props.dataAnalytics.data != null && this.props.dataAnalytics.data.patientBillableHoursGraphs != null && this.props.dataAnalytics.data.patientBillableHoursGraphs.length > 0) {
      this.props.dataAnalytics.data.patientBillableHoursGraphs.map((obj, index) => {
            let dataObj = {}
            dataObj['name'] = obj.title;
            dataObj['y'] = obj.y;       
            totalHours = totalHours + parseFloat(obj.y);
            finalData.push(dataObj);
        });       

        totalHoursToDisplay = totalHours.toFixed(2).toString();
    }   
   
    Highcharts.setOptions({      
      lang: {
        thousandsSep: ','
      },
      colors: ['#ED561B', '#DDDF00', '#50B432', '#24CBE5', '#fa050d', '#058DC7', '#64E572', '#FF9655', '#FFF263']  
  });

    Highcharts.chart('analyticsDataDivScheduledHours', {
      chart: {
          type: 'column'
      },
      title: {
          text: 'Total Hours: ' + totalHoursToDisplay
      },

      yAxis: {
          gridLineWidth: gridlinesWidth,
          minorGridLineWidth: gridlinesWidth,
          title: {
          text: `<b>${xAxisLabel}</b>`
          }
      },

      legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle',
          enabled: false
      },

      xAxis: {
          title: {
              text: `<b>${yAxisLabel}</b>`,
          },
          type: 'category'
      },

      tooltip: {
          enabled: false
      },

      credits: {
          enabled: false
      },

      plotOptions: {
          series: {
              cursor: 'pointer',
              borderWidth: 0,
              dataLabels: {
                  enabled: true
              },
              events: {
                  legendItemClick: function () {
                      return false
                  }
              },
              marker: {
                  enabled: true        
              }
          }
      },

      series: [
          {
              colorByPoint: true,
              data: finalData
          }
      ],

      responsive: {
          rules: [{
              condition: {
                  maxWidth: 500
              },
              chartOptions: {
                  legend: {
                      layout: 'horizontal',
                      align: 'center',
                      verticalAlign: 'bottom'
                  }
              }
          }]
      },

      navigation: {
          buttonOptions: {
              verticalAlign: 'top',
              x: -100
          }
      },

      lang: {
          contextButtonTitle: 'Click to open'
      },

      exporting: {
          buttons: {
              contextButton: {
                  menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "downloadCSV", "downloadXLS"]
              }
          },
          chartOptions: {
              colors: ['#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000'],
          }
      }
  });
}

  render() {
    //const { handleSubmit, OrganizationAuthorization } = this.props;
   // const authList =  (OrganizationAuthorization && OrganizationAuthorization.data) || []
    return (
      <div>
        <div className="row">
          <div className="col-sm-12">
                <form className="readmin-form custom_form" >                
                  <div className="row end-flex">         
                    <div className="col-sm-3 ml-10">
                      <Field name="FromBillableHoursDate"
                        placeholder="From Date"
                        locale="en-US"
                        selected={this.props.FromBillableHoursDate}
                        onDateChange={this.props.onBillableKPIDateChange}
                        openToYearSelection={true}
                        component={renderDateField} />
                    </div>
                    <div className="col-sm-3 ml-10">
                      <Field name="ToBillableHoursDate"
                        placeholder="To Date"
                        locale="en-US"
                        minDate = {this.props.FromBillableHoursDate}
                        selected={this.props.ToBillableHoursDate}
                        openToYearSelection={true}
                        onDateChange={this.props.onBillableKPIDateChange}
                        component={renderDateField} />
                    </div>
                    <div className="col-sm-3 ml-10 mt-35">
                        <Field name="billableLocationIds"
                          label="Location"
                          handleNewRequest={this.props.handleBillableChange}
                          options={this.props.userLocationList}
                          component={renderAutoCompleteScheduling}
                        />
                    </div>
                    <div className="col-sm-3 ml-10 mt-35">
                      <Field name="billablePayerIds"
                        label="Payer"
                        handleNewRequest={this.props.handleBillableChange}
                        options={this.props.masterInsuranceCompanies}
                        component={renderAutoCompleteScheduling}
                      />
                    </div>        
                    <div className="col-sm-3 ml-10 mt-35">
                      <Field
                        name="billableAppointmentTypeIds"
                        label="Appointment Type"
                        handleNewRequest={this.props.handleBillableChange}
                        options={this.props.appointmentType}
                        component={renderAutoCompleteScheduling} />
                    </div>       
                    <div className="col-sm-3 ml-10 mt-35">
                      <Field name="billableStaffIds"
                        label="Staff"
                        handleNewRequest={this.props.handleBillableChange}
                        options={this.props.allStaffs}
                        component={renderAutoCompleteScheduling}
                      />
                    </div>              
                    <div className="col-sm-3 ml-10 mt-35">
                      <Field
                        name="billablePatientIds"
                        label="Client"
                        handleNewRequest={this.props.handleBillableChange}
                        options={this.props.patientlist}
                        component={renderAutoCompleteScheduling}
                        fullWidth={true}
                      />                      
                    </div>                                        
                    <div className="col-sm-3 mt-20">
                      <Field
                        className="mt20 mb0"
                        name="isBillableHoursOnly"
                        label="Billable Hours Only"
                        onChange={(e) => this.props.checkBillableAllHoursStatus(e)}
                        component={renderCheckBox}
                      />
                    </div> 
                  </div>
                  <div className="row">
                    <div className="col-sm-3 mt-30">
                      <Field
                        name="tags" 
                        label="Client and Staff Tags"
                        handleNewRequest={this.props.handleTagChange}
                        options={this.props.masterTagsForAll}
                        component={renderAutoCompleteMultipleSelection} />
                    </div>
                    <div className="col-sm-3 mt-30">
                      <Field
                          name="ExcludeTag"
                          label="Exclude Tags"
                          component={renderCheckBox}
                          onChange={(e) => this.props.isExcludeTagHandler(e)}
                        />
                    </div>
                    <div className="col-sm-3 mt-30"></div>
                    <div className="reset-btn col-sm-3 btn_rt">
                      <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                    </div>
                  </div>
              </form>    
          </div>
        </div>
        <div className='row'>
            <div className='col-sm-11'>
              {
                  this.props.loading ? "Loading..." :
                  <div>                         
                      {this.state.xAxisDateOption.length > 0 ? 
                      <div className='row'>                          
                          <div className='col-sm-6'></div>
                      </div>   
                      : null}
                      <div id='analyticsDataDivScheduledHours' style={{ height: '500px' }} /> 
                  </div>
              }
            </div>
          </div>        
      </div>
    );
  }
}

KPIScheduledHours = reduxForm({
  form: 'KPIScheduledHoursForm',
})(KPIScheduledHours);

function mapStateToProps(state) {   
  return {
    dataAnalytics: state.staff_dashboard ? state.staff_dashboard.OrganizationBillableHoursGraph : {},    
    RightPanel_loading: state.staff_dashboard.RightPanel_loading,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
}

export default connect(mapStateToProps, { getOrganizationBillableHoursGraph })(KPIScheduledHours);



// WEBPACK FOOTER //
// ./src/adminCharts/KPIScheduledHours.js